import { tr } from '../../i18n/text';
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSimulador } from '../Context_simulador/simulador_context';
import { ReactComponent as SidebarLogo } from '../../img/pecuaria-sidebar.svg';
import { getNavigationItems, isNavigationItemActive } from './navigationConfig';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'pecuaria.desktop-navigation-collapsed';

const getInitialCollapsedState = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

function DesktopNavigation() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const { systemMode } = useSimulador();
  const [collapsed, setCollapsed] = useState(getInitialCollapsedState);
  const items = getNavigationItems(systemMode);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      // A navegação continua funcional quando o armazenamento está indisponível.
    }
  }, [collapsed]);

  return (
    <aside
      className="app-desktop-nav"
      data-collapsed={collapsed ? 'true' : 'false'}
      aria-label={t("navigation.application")}
    >
      <div className="app-desktop-nav__brand">
        <SidebarLogo
          role="img"
          aria-label={tr("Pecuária.io")}
          className="app-desktop-nav__logo"
        />
        <button
          type="button"
          className="app-desktop-nav__toggle"
          aria-label={t(collapsed ? "navigation.expand" : "navigation.collapse")}
          aria-expanded={!collapsed}
          onClick={() => setCollapsed((current) => !current)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="app-desktop-nav__toggle-icon">
            <rect x="3" y="4" width="18" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <path d="M9 4v16M5.5 8h1M5.5 12h1" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <nav className="app-desktop-nav__items" aria-label={t("navigation.sections")}>
        {items.map((item) => {
          const active = isNavigationItemActive(item, location.pathname);

          return (
            <NavLink
              key={item.id}
              to={item.path}
              aria-current={active ? 'page' : undefined}
              title={collapsed ? t(item.labelKey) : undefined}
              className={`app-desktop-nav__item${active ? ' app-desktop-nav__item--active' : ''}`}
            >
              <img src={item.resolvedIcon} alt="" className="app-desktop-nav__item-icon" />
              <span className="app-desktop-nav__label">{t(item.labelKey)}</span>
            </NavLink>
          );
        })}
      </nav>

    </aside>
  );
}

export default React.memo(DesktopNavigation);
